module.exports = __webpack_public_path__ + "media/images/icons/twotone/cloud-00c3bf47cc2959ec3e0dc4e6ca5ef2f2.svg";